import React, { Fragment, PureComponent } from 'react';
import { Country } from '~/Api/Country';
import { Product as GeneralProduct } from '~/Api/Product';
import { Product } from '~/Api/User/ProductGroup/SiMaxPrice';

import Header from './Header/Header';
import Row, { EmptyRow, OnChangeListener, OnSelectListener, Values } from './Row';

export interface ProductRow {
	country: Country | null;
	product: Product | null;
	usedForCalculation: boolean;
}

export type ProductValues = Values;

interface Props {
	products: ProductRow[];
	productValues: { [key in string]: Values };
	referencePackageSize: number | null;
	referenceDosageStrength: number | null;
	detailLink(product: { id: string }): { pathname: string; search: string };
	highlightProductId: string | null;
	lastSelectedProductId: string | null;
	disableSelection: boolean;
	showReferenceDataSource: boolean;
	historicData: boolean;
	onChange: OnChangeListener;
	onSelect: OnSelectListener;
	onSave(): void;
	checkedRows?: GeneralProduct[];
	checkRow?(product: GeneralProduct, checked: boolean): void;
}

export default class ProductsTable extends PureComponent<Props> {
	static defaultProps = {
		referencePackageSize: null,
		referenceDosageStrength: null,
		highlightProductId: null,
		lastSelectedProductId: null,
		disableSelection: false,
		showReferenceDataSource: false,
	};

	renderRow(siMaxPriceProduct: Product, usedForCalculation: boolean) {
		const {
			productValues,
			referencePackageSize,
			referenceDosageStrength,
			disableSelection,
			showReferenceDataSource,
			highlightProductId,
			lastSelectedProductId,
			historicData,
			detailLink,
			onChange,
			onSelect,
			onSave,
			checkRow,
		} = this.props;
		const { product } = siMaxPriceProduct;
		const checked = this.props.checkedRows?.some((row) => row.id === product.id);

		return (
			<Row
				detailLink={detailLink}
				disableSelection={disableSelection}
				highlightProduct={highlightProductId === product.id}
				historicData={historicData}
				checked={Boolean(checked)}
				checkRow={(value) => checkRow?.(product, value)}
				key={product.id}
				lastSelectedProduct={lastSelectedProductId === product.id}
				referenceDosageStrength={referenceDosageStrength}
				referencePackageSize={referencePackageSize}
				showReferenceDataSource={showReferenceDataSource}
				siMaxPriceProduct={siMaxPriceProduct}
				usedForCalculation={usedForCalculation}
				values={productValues[product.id]}
				onChange={onChange}
				onSave={onSave}
				onSelect={onSelect}
			/>
		);
	}

	render() {
		const { products } = this.props;

		return (
			<Fragment>
				<Header />
				{products.map((optionalProduct) => {
					const { country, product, usedForCalculation } = optionalProduct;
					return product !== null ? (
						this.renderRow(product, usedForCalculation)
					) : (
						<EmptyRow country={country} key={country?.alpha2 || ''} />
					);
				})}
			</Fragment>
		);
	}
}
